export default __webpack_public_path__ + "static/media/twiiterDeskFill.da7cc2ec.svg";